import React from "react";
import GlobalTrade from "./GlobalTrade";
import VideoComex from "./VideoComex";
// Estado global (Zustand)
// import useStore from "../store/useStore";

export default function Features(data) {
  // const {  fetchHomeVideos } = useStore();
  // Cargamos datos de home y SEO cuando se monta el componente
  // useEffect(() => {
  //   fetchHomeVideos();
  // }, [fetchHomeVideos]);
  // Validación para evitar error si data o data.data es undefined
  const featureData =
    Array.isArray(data?.data) && data.data[0] ? data.data[0] : {};

  return (
    <div className="   ">
      <GlobalTrade />

      <div className="flex flex-col mb-[40px] mt-[70px] md:mt-[100px] lg:mt-[90px]  items-center w-full text-sidom-dark dark:text-sidom-light">
        <VideoComex
          key={featureData?.id}
          video={featureData?.video?.url}
          controls={false}
          autoPlay={true}
          muted={true}
          loop={true}
        />
        <div className="bg-sidom-blue w-full px-2 md:px-0 lg:px-0">
          <div className="w-full container  text-left">
            <h1 className="text-sidom-orange text-3xl md:text-[40px] lg:text-[45px] leading-tight mt-[60px] font-extrabold">
              {featureData?.titulo || ""}
            </h1>
          </div>

          <div className="w-full container text-sidom-light  mt-[60px] leading-[1.3] flex justify-center">
            <div className=" text-left  text-xs sm:text-sm md:text-base lg:text-xl leading-relaxed space-y-6 mb-[60px] ">
              {Array.isArray(featureData?.descripcion)
                ? featureData.descripcion.map((bloque, idx) => {
                    // Detectar tipo de bloque (ej: heading, paragraph)
                    const type = bloque.type || "paragraph";
                    let Tag = "p";
                    let className = "";
                    if (type === "heading1") {
                      Tag = "h1";
                      className = "text-3xl md:text-4xl font-bold mb-2";
                    } else if (type === "heading2") {
                      Tag = "h2";
                      className = "text-2xl md:text-3xl font-bold mb-2";
                    } else if (type === "heading3") {
                      Tag = "h3";
                      className = "text-xl md:text-2xl font-bold mb-2";
                    } else if (type === "paragraph") {
                      Tag = "p";
                      className = "mb-2";
                    }
                    return (
                      <Tag key={idx} className={className}>
                        {Array.isArray(bloque.children)
                          ? bloque.children.map((c, i) => {
                              let style = "";
                              if (c.bold) style += " font-bold";
                              if (c.italic) style += " italic";
                              if (c.underline) style += " underline";
                              // Si hay size, lo agregamos
                              if (c.size === "large")
                                style += " text-xl md:text-2xl";
                              if (c.size === "medium")
                                style += " text-base md:text-lg";
                              if (c.size === "small") style += " text-sm";
                              return (
                                <span key={i} className={style.trim()}>
                                  {c.text}
                                </span>
                              );
                            })
                          : null}
                      </Tag>
                    );
                  })
                : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
